import React, { useState, useEffect } from "react";
import Close from '@mui/icons-material/Close';
import { Box, Card, Grid, Typography, Button, Paper, Tooltip, Divider, Autocomplete, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, alpha } from "@mui/material";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import GlobalConfig from "../../../config/date/GlobalConfig";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import CustomDatePicker from "../../../components/CustomDatePicker";

const ReWinderDetailReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);
    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };


    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };

        setLoading(true);

        callApi(API_ENDPOINTS.REPORT_GetreportProductionGetReWinderDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                if (data && data.length > 0) {
                    setLoadingData(data);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                    setLoadingData([]);
                    alert("No Data Found");
                }

            })
            .catch(error => {
                alert(error);
            });

    };



    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]);


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
        child_reel_number_ref: '',
        grade: '',
        reel_sheet: ''
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "P.O NO.", key: "po_no" },
        { header: "DATE", key: "date" },
        { header: "SHIFT", key: "shift_code" },
        { header: "ROLL NO", key: "pr_number" },
        { header: "REEL NO", key: "child_reel_number" },
        { header: "QUALITY", key: "item_code" },
        { header: "GSM", key: "gsm" },
        { header: "REEL SIZE", key: "reelsize" },
        { header: "NO OF CUTS", key: "no_of_cuts" },
        { header: "LENGTH (METERS)", key: "reel_length" },
        { header: "REEL DIA", key: "reel_od" },
        { header: "WEIGHT", key: "achieved_qty" },
        { header: "SIZE1", key: "width" },
        { header: "SIZE2", key: "length" },
        { header: "REPULP /HOLD", key: "qc_status" },
        { header: "REMARKS", key: "production_remarks" },
        { header: "GRADE", key: "grade" },
        { header: "REEL REF. NO", key: "child_reel_number_ref" },
        { header: "REEL/SHEET", key: "reel_sheet" },
        { header: "REEL", key: "reel_wt" },
        { header: "SHEET WT.", key: "sheet_wt" },
        { header: "REAM WT.", key: "ream_wt" },
        { header: "BUNDLE WT.", key: "bundle_wt" },
        { header: "FG G1", key: "fg_wt_g1" },
        { header: "FG SL", key: "fg_wt_sl" },
        { header: "REPULP QTY", key: "repulp_qty_new" }
    ];

    const dateColumnIndexes = [1]; // "DATE"
    const numberColumnIndexes = [19, 20, 21, 22, 23]; // "REEL", "SHEET WT.", "REAM WT.", "BUNDLE WT.", "FG"


    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData,
            fileName: 'WIP Child Reel Production Detail Report.xlsx',
            sheetName: 'WIP Child Reel Production',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
            numberColumnIndexes

        });

        // Prepare the data with headers
        // const formattedData = filteredData.map(row => ({
        //     "P.O NO.": row.po_no,
        //     "DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "SHIFT": row.shift_code,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.child_reel_number,
        //     "QUALITY": row.item_code,
        //     "GSM": row.gsm,
        //     "REEL SIZE": row.reelsize,
        //     "NO OF CUTS": row.no_of_cuts,
        //     "LENGTH (METERS)": row.reel_length,
        //     "REEL DIA": row.reel_od,
        //     "WEIGHT": row.achieved_qty,
        //     "SIZE1": row.width,
        //     "SIZE2": row.length,
        //     "REPULP /HOLD": row.qc_status,
        //     "REMARKS": row.production_remarks,
        //     "GRADE": row.grade,
        //     "REEL REF. NO": row.child_reel_number_ref,
        //     "REEL/SHEET": row.reel_sheet,
        //     "REEL": isNaN(parseFloat(row.reel_wt)) ? row.reel_wt : parseFloat(row.reel_wt),
        //     "SHEET WT.": isNaN(parseFloat(row.sheet_wt)) ? row.sheet_wt : parseFloat(row.sheet_wt),
        //     "REAM WT.": isNaN(parseFloat(row.ream_wt)) ? row.ream_wt : parseFloat(row.ream_wt),
        //     "BUNDLE WT.": isNaN(parseFloat(row.bundle_wt)) ? row.bundle_wt : parseFloat(row.bundle_wt),
        //     "FG": isNaN(parseFloat(row.fg_wt)) ? row.fg_wt : parseFloat(row.fg_wt),


        // }));



    };

    const HandleClose = () => {
        handleExportToExcel();
    }


    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };


    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);

    // const uniqueValues = {
    //     po_no: [...new Set(loadingData.map(row => row.po_no))],
    //     shift_code: [...new Set(loadingData.map(row => row.shift_code))],
    //     pr_number: [...new Set(loadingData.map(row => row.pr_number))],
    //     child_reel_number: [...new Set(loadingData.map(row => row.child_reel_number))],
    //     item_code: [...new Set(loadingData.map(row => row.item_code))],
    //     gsm: [...new Set(loadingData.map(row => row.gsm))],
    //     grade: [...new Set(loadingData.map(row => row.grade))],
    //     reel_sheet: [...new Set(loadingData.map(row => row.reel_sheet))],
    // };
    const uniqueValues = {
        po_no: [...new Set(loadingData.map(r => r.po_no ?? ""))],
        shift_code: [...new Set(loadingData.map(r => r.shift_code ?? ""))],
        pr_number: [...new Set(loadingData.map(r => r.pr_number ?? ""))],
        child_reel_number: [...new Set(loadingData.map(r => r.child_reel_number ?? ""))],
        item_code: [...new Set(loadingData.map(r => r.item_code ?? ""))],
        gsm: [...new Set(loadingData.map(r => r.gsm ?? ""))],
        grade: [...new Set(loadingData.map(r => r.grade ?? ""))],   // 🔥 important one
        reel_sheet: [...new Set(loadingData.map(r => r.reel_sheet ?? ""))],
    };



    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const columns = ['po_no', 'date', 'shift_code', 'pr_number', 'child_reel_number', 'item_code', 'gsm', 'reelsize', 'no_of_cuts', 'reel_length', 'reel_od', 'achieved_qty', 'width', 'length', 'qc_status', 'production_remarks', 'grade', 'child_reel_number_ref', 'reel_sheet', 'reel_wt', 'sheet_wt', 'ream_wt', 'bundle_wt', 'fg_wt_g1', 'fg_wt_sl', 'repulp_qty_new'];

    const autoCompleteColumns = ['po_no', 'shift_code', 'pr_number', 'child_reel_number', 'item_code', 'gsm', 'grade', 'reel_sheet'];

    const totals = {
        achieved_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.achieved_qty) || 0), 0),
        reel_wt: filteredData.reduce((sum, r) => sum + (parseFloat(r.reel_wt) || 0), 0),
        sheet_wt: filteredData.reduce((sum, r) => sum + (parseFloat(r.sheet_wt) || 0), 0),
        ream_wt: filteredData.reduce((sum, r) => sum + (parseFloat(r.ream_wt) || 0), 0),
        bundle_wt: filteredData.reduce((sum, r) => sum + (parseFloat(r.bundle_wt) || 0), 0),
        fg_wt_g1: filteredData.reduce((sum, r) => sum + (parseFloat(r.fg_wt_g1) || 0), 0),
        fg_wt_sl: filteredData.reduce((sum, r) => sum + (parseFloat(r.fg_wt_sl) || 0), 0),
        repulp_qty_new: filteredData.reduce((sum, r) => sum + (parseFloat(r.repulp_qty_new) || 0), 0),
    };


    return (
        <>
            <Grid container alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-start" }} >
                <Box ml={1} >
                    <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >WIP Child Reel Production Detail Report</Typography>
                </Box>
                <Grid item mt="2px" ml="5px" mr="auto" justifyContent="center">
                    <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                </Grid>
            </Grid>

            <Divider />

            <Grid container alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-start" }} >
                <Grid ml={1} item xs={2} sm={3} md={1} lg={1} xl={1} mt="5px">
                    <CustomDatePicker
                        value={FromDate}
                        onChange={(date) => handleDateChange2(date)}
                        autoFocus={true}
                    />
                </Grid>

                <Grid item mt="2px" ml="10px" mr="10px">
                    <Typography fontWeight="bold">-</Typography>
                </Grid>

                <Grid item xs={2} sm={3} md={1} lg={1} xl={1} mt="5px" mr="10px">
                    <CustomDatePicker
                        value={ToDate}
                        onChange={(date) => handleDateChange1(date)}
                    />
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                <Grid item mt="2px" ml="0px" mr="auto">
                    <Tooltip title="Download Report" onClick={HandleClose}>
                        <IconButton >
                            <FileDownloadIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>

            <Divider />
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>
                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table size="small">
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow >

                                        <TableCell sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap" }}>PO NO.</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 80, whiteSpace: "nowrap" }}>DATE</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>SHIFT</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>ROLL NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 110, whiteSpace: "nowrap" }}>REEL NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>QUALITY </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>GSM </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REEL SIZE </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>NO OF CUTS </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>LENGTH (METERS) </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REEL DIA </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>WEIGHT </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}> SIZE1</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}> SIZE2</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REPULP /HOLD</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}> REMARKS</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}> GRADE</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REEL REF.NO</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REEL/SHEET</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REEL</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>SHEET WT.</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REAM WT.</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>BUNDLE WT.</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>FG G1</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>FG SL</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>REPULP QTY</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={11} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.achieved_qty.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE1 */}
                                        <TableCell /> {/* SIZE2 */}
                                        <TableCell /> {/* REPULP /HOLD */}
                                        <TableCell /> {/* REMARKS */}
                                        <TableCell /> {/* GRADE */}
                                        <TableCell /> {/* REEL REF.NO */}
                                        <TableCell /> {/* REEL/SHEET */}
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.reel_wt.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.sheet_wt.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.ream_wt.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.bundle_wt.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.fg_wt_g1.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.fg_wt_sl.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.repulp_qty_new.toFixed(2)}</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{
                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>

                                            <TableCell >{row.po_no}</TableCell>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.child_reel_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reelsize}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.no_of_cuts}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_length}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_od}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.achieved_qty}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.width}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.length}</TableCell>
                                            <TableCell>{row.qc_status}</TableCell>
                                            <TableCell>{row.production_remarks}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell>{row.child_reel_number_ref}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_sheet}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_wt}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.sheet_wt}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.ream_wt}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.bundle_wt}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.fg_wt_g1}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.fg_wt_sl}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.repulp_qty_new}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}

                    </TableContainer>
                </CustomTableContainer>
                <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />

            </ResponsiveBox>
        </>
    )
};
export default ReWinderDetailReport;